(function () {
  function isExternal(href) {
    try {
      const url = new URL(href, window.location.href);
      if (url.protocol !== 'http:' && url.protocol !== 'https:') return true;
      const host = url.hostname.replace(/^www\./i, '').toLowerCase();
      const current = window.location.hostname.replace(/^www\./i, '').toLowerCase();
      if (host === current) return false;
      if (host === 'jlab.com') return false;
      return true;
    } catch {
      return true;
    }
  }

  function linkHasWarning(link, external, newWindow) {
    const describedBy = link.getAttribute('aria-describedby') || '';
    if (describedBy.split(/\s+/).includes('a11y-new-window-message')) return true;

    const label = (link.getAttribute('aria-label') || '').toLowerCase();
    if (/external|new window|new tab/.test(label)) return true;

    const title = (link.getAttribute('title') || '').toLowerCase();
    if (/external|new window|new tab|opens in/.test(title)) return true;

    return [...link.querySelectorAll('.visually-hidden')].some((node) => {
      const text = node.textContent.trim();
      return text === external || text === newWindow;
    });
  }

  function annotateTargetBlankLinks() {
    const strings = window.accessibilityStrings;
    if (!strings?.linkExternal || !strings?.linkNewWindow) return;

    document.querySelectorAll('a[target="_blank"]').forEach((link) => {
      if (link.dataset.targetBlankA11y === 'true') return;
      if (linkHasWarning(link, strings.linkExternal, strings.linkNewWindow)) {
        link.dataset.targetBlankA11y = 'true';
        return;
      }

      const span = document.createElement('span');
      span.className = 'visually-hidden';
      span.textContent = isExternal(link.href) ? strings.linkExternal : strings.linkNewWindow;
      link.appendChild(span);
      link.dataset.targetBlankA11y = 'true';
    });
  }

  let pending = false;
  function scheduleAnnotate() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      annotateTargetBlankLinks();
    });
  }

  function init() {
    annotateTargetBlankLinks();
    if (window.__targetBlankA11yObserver) return;
    window.__targetBlankA11yObserver = new MutationObserver(scheduleAnnotate);
    window.__targetBlankA11yObserver.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
